<div class="col-xs-12" style="margin-bottom:10px;" *ngIf="field.show === 'always' || field.show === 'edit'">
    <div *ngFor="let value of values; let i = index; let first = first; trackBy: trackByIndex" class="row">
        <div class="col-xs-5">
            <span class="form-label" style="line-height:40px">{{field.title}}</span>
        </div>
        <div class="col-xs-7 input-container">
        	<div [ngSwitch]="field.type">
            
                <div *ngSwitchCase="'STRING'">
                    <textarea class="form-control auto-expand"
                    	autoExpand
                        [(ngModel)]="values[i]" 
                        [ngModelOptions]="{ updateOn: 'blur' }"
                        #fieldControl="ngModel"
                        [attr.id]="field.name + i"
                        name="{{ field.name + i }}"
                        minlength="{{field.min}}" 
                        maxlength="{{field.max}}"
                        [disabled]="field.readOnly" 
                        [required]="field.required"   
                        placeholder="{{field.placeholder}}" 
                        title="{{field.placeholder}}" 
                        [attr.aria-label]="field.title + ' value ' + i"                        
                        rows="1" 
                        style="margin-bottom:10px;">
                    </textarea>
                    <span *ngIf="fieldControl?.errors?.['required']" class="required">{{LOCALIZATION.required}}</span>                                                  
                </div>
                
                <div *ngSwitchCase="'DATE'">
                    <input type="text" 
                           class="item-input flatpickr" 
                           style="margin-bottom:10px;"                            
                           [attr.id]="'daterange_' + field.name + i"
                           name="{{ 'daterange_' + field.name + i }}"
                           [(ngModel)]="values[i]"
                           #fieldControl="ngModel"
                           placeholder='{{field.placeholder}}' 
                           title="{{field.placeholder}}"
                           [disabled]="field.readOnly"
                           [required]="field.required"                                 
                           (focus)="openDatePicker(i)" 
                           
		                   dateValidate
		                   [dateValidateValue]="values[i]"
		                   
		                   dateRangeValidate
		                   [dateRangeValidateValue]="values[i]"
		                   [dateRangeValidateMin]="datePickerOptions['minDate']"
		                   [dateRangeValidateMax]="datePickerOptions['maxDate']"
                           />                           
                    <span>
                        <button type="button" 
                        	class="btn btn-default" 
                        	(click)="openDatePicker(i)" 
                        	[hidden]="field.readOnly"
                        	title="{{LOCALIZATION.openCalendar}}"
                        	[attr.aria-label]="LOCALIZATION.openCalendar">
                            	<i class="fas fa-calendar-alt" aria-hidden="true"></i>
                        </button>
                    </span>                            
                    <span *ngIf="fieldControl?.errors?.['datevalidate']" class="required">{{values[i]}} - {{ LOCALIZATION.dateInvalid | formatString: dateFormat }}</span>
                    <span *ngIf="fieldControl?.errors?.['datevalidateminmax']" class="required">
                        {{ LOCALIZATION.dateInvalidMinMax | formatString:
                            (datePickerOptions['minDate'] && datePickerOptions['minDate'].isValid() ? datePickerOptions['minDate'].format(dateFormat) : "anytime") :
                            (datePickerOptions['maxDate'] && datePickerOptions['maxDate'].isValid() ? datePickerOptions['maxDate'].format(dateFormat) : "anytime")
                        }}
                    </span>
                    <span *ngIf="fieldControl?.errors?.['required']" class="required">{{LOCALIZATION.required}}</span>
                </div>
                
                <div *ngSwitchCase="'BOOLEAN'">
                    <label style="display:inline;" class="control control--checkbox">
                        <input type="checkbox" class="item-input" style="margin-bottom:10px;"
                               [(ngModel)]="values[i]" 
                               #fieldControl="ngModel"
                               [attr.id]="field.name + i"
                               name="{{ field.name + i }}"
                               [disabled]="field.readOnly" 
                               [required]="field.required"
                               placeholder="{{field.placeholder}}" 
                               title="{{field.placeholder}}" 
                               [attr.aria-label]="field.title + ' value ' + i" />
                        <div class="control__indicator"></div>
                    </label>
                    <span *ngIf="fieldControl?.errors?.['required']" class="required">{{LOCALIZATION.required}}</span>
                </div>
                
                <div *ngSwitchCase="'EMAIL'">
                    <input type="email" class="item-input" style="margin-bottom:10px;"
                           [(ngModel)]="values[i]" 
                           #fieldControl="ngModel"
                           [attr.id]="field.name + i"
                           name="{{ field.name + i }}"
                           [disabled]="field.readOnly" 
                           [required]="field.required"
                           minlength="{{field.min}}"
                           maxlength="{{field.max}}"
                           placeholder="{{field.placeholder}}" 
                           title="{{field.placeholder}}" 
                           [attr.aria-label]="field.title + ' value ' + i" />
                    <span *ngIf="fieldControl?.errors?.['required']" class="required">{{LOCALIZATION.required}}</span>      
                </div>
                
                <div *ngSwitchCase="'NUMBER'">
                    <input type="number" class="item-input" style="margin-bottom:10px;"
                           [(ngModel)]="values[i]"
                           #fieldControl="ngModel"
                           [attr.id]="field.name + i"
                           name="{{ field.name + i }}"
                           min="{{field.min}}"
                           max="{{field.max}}"
                           [disabled]="field.readOnly" 
                           [required]="field.required"
                           placeholder="{{field.placeholder}}" 
                           title="{{field.placeholder}}"
                           [attr.aria-label]="field.title + ' value ' + i" />
                    <span class="help-block required" *ngIf="fieldControl?.invalid && fieldControl?.touched">
                        {{ LOCALIZATION.numberInvalidMinMax| formatString:
                        	(field.min ? field.min : "(any value)") :
                        	(field.max ? field.max : "(any value)")
                        }}
                    </span> 
                    <span *ngIf="fieldControl?.errors?.['required']" class="required">{{LOCALIZATION.required}}</span>       
                </div>
                
                <div *ngSwitchCase="'WKT'">
                    <input type="text" class="item-input" style="margin-bottom:10px;"
                           [(ngModel)]="values[i]"
                           #fieldControl="ngModel"
                           [attr.id]="field.name + i"
						   name="{{ field.name + i }}"
                           minlength="{{field.min}}" 
                           maxlength="{{field.max}}"
                           [disabled]="field.readOnly" 
                           [required]="field.required"
                           placeholder="{{field.placeholder}}"
                           title="{{field.placeholder}}"
                           [attr.aria-label]="field.title + ' value ' + i" />
                    <span *ngIf="fieldControl?.errors?.['required']" class="required">{{LOCALIZATION.required}}</span>
                </div>
                
                <div *ngSwitchCase="'LIST'">
					<select class="form-control"
                            [(ngModel)]="values[i]"
                            #fieldControl="ngModel"
                            [attr.id]="field.name + i"
                            name="{{ field.name + i }}" 
                            title="{{field.placeholder}}"
                            [attr.aria-label]="field.title + ' value ' + i"
                            [disabled]="field.readOnly" 
                            [required]="field.required"
					    	(ngModelChange)="updateFn(field, $event)">
					    <option *ngFor="let option of field.filteredOptions" [value]="option.value">
					        {{ option.name }}
					    </option>					    
					</select>                    
                    <span *ngIf="fieldControl?.errors?.['required']" class="required">{{LOCALIZATION.required}}</span>
                </div>
				<div *ngSwitchCase="'DATE_RANGE'">
                    <textarea class="form-control auto-expand"
                    	autoExpand
                        [(ngModel)]="values[i]" 
                        [ngModelOptions]="{ updateOn: 'blur' }"
                        #fieldControl="ngModel"
                        [attr.id]="field.name + i"
                        name="{{ field.name + i }}"
                        minlength="{{field.min}}" 
                        maxlength="{{field.max}}"
                        [disabled]="field.readOnly" 
                        [required]="field.required"   
                        placeholder="{{field.placeholder}}" 
                        title="{{field.placeholder}}" 
                        [attr.aria-label]="field.title + ' value ' + i"                        
                        rows="1" 
                        style="margin-bottom:10px;">
                    </textarea>
                    <span *ngIf="fieldControl?.errors?.['required']" class="required">{{LOCALIZATION.required}}</span>                                                  
                </div>
				<button *ngIf="!field.readOnly && first && !field.isdependent && field.ismultiple"
					class="btn btn-sm btn-circle" 
					title="Add Value"
					aria-label="Add Value"
					(click)="addValue()">
					<i class="fa fa-plus accent-color" aria-hidden="true"></i>
				</button>
				<button *ngIf="!field.readOnly && !first"
					class="btn btn-sm btn-circle" 
					title="Remove Value"
					aria-label="Remove Value"
					(click)="removeValue(i)">
					<i class="fa fa-trash text-red" aria-hidden="true"></i>
				</button>
				<button *ngIf="!field.readOnly && field.name === 'geo' && mapEnabled"
					class="btn btn-sm btn-circle" 
					title="Geotag with a saved location"
					aria-label="Geotag with a saved location"
					(click)="onGeotag(i)">
					<i class="fa fa-globe accent-color" aria-hidden="true"></i>
				</button>
				<button *ngIf="!field.readOnly && field.name === 'browsepath'"
					class="btn btn-sm btn-circle" 
					title="Edit the browse path"
					aria-label="Edit the browse path"
					(click)="onBrowseEdit(i)">
					<i class="far fa-edit accent-color" aria-hidden="true"></i>
				</button>
			</div>
        </div>
    </div>
</div>
